import React from 'react';
import styles from './LoadingIndicator.module.scss';
import cx from 'classnames';
export const LoadingIndicator = ({ loading, size = 'default' }) => {
    if (loading === false) {
        return null;
    }
    return (<div className={cx(styles.loadingIndicator, {
            [styles.large]: size === 'large',
            [styles.default]: size === 'default',
        })}/>);
};
